/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';
import AccountService from 'cio/services/account';
import { tracked } from '@glimmer/tracking';
import { HelpModalComponentArgs } from 'cio/components/help-modal';
import { action } from '@ember/object';
import { FlyKeyboardEvent } from '@customerio/fly-components/types/fly-components/events';

export default class UpsellModalBody extends Component<HelpModalComponentArgs> {
  @service account!: AccountService;
  @service auth!: AuthService;

  @tracked message = '';

  get canSubmit() {
    return !this.args.isSubmitting;
  }

  @action
  updateMessage(evt: FlyKeyboardEvent<HTMLTextAreaElement>) {
    this.message = evt.target.value;
  }

  @action
  onSubmitAction(e: Event) {
    if (!this.canSubmit) {
      return;
    }

    e.preventDefault();

    this.args.onSubmit({
      message: this.message,
    });
  }
}
